import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  CardContainer,
  ImageWrapper,
  CardImage,
  CardVideo,
  CardFooter,
  Metrics,
  Metric,
  BookmarkIconWrapper
} from "./MediaCard.styled";
import { motion } from "framer-motion";
import { Bookmark } from "@untitledui/icons/Bookmark";
import { BookmarkCheck } from "@untitledui/icons/BookmarkCheck";
import { ActionsGlobalMediaLibrary } from "../../../../Actions/ActionsGlobalMediaLibrary/ActionsGlobalMediaLibrary";

const MediaCard = ({
  isVideo = false,
  src,
  showKPIs = true,
  emitNewImageSelection = null,
  isPopupPreview = false,
  assetPublicId,
  type,
  isLiked = false,
  showShutterstockSearcher = false
}) => {
  const { t } = useTranslation();
  const [isFavorite, setIsFavorite] = useState(isLiked);
  const [isJumping, setIsJumping] = useState(false);

  const handleBookmarkClick = (e) => {
    e.stopPropagation();
    const newIsLiked = !isFavorite;
    setIsFavorite(newIsLiked);
    setIsJumping(true);
    setTimeout(() => setIsJumping(false), 350);
    if (assetPublicId && type) {
      ActionsGlobalMediaLibrary.likeCloudinaryAsset({
        assetPublicId,
        type,
        isLiked: newIsLiked
      });
    }
  };

  return (
    <CardContainer
      showKPIs={showKPIs}
      onClick={() => isPopupPreview && emitNewImageSelection(src)}
      isPopupPreview={isPopupPreview}
    >
      <ImageWrapper>
        {!showShutterstockSearcher && (
          <BookmarkIconWrapper
            as={motion.div}
            animate={isJumping ? { y: -12 } : { y: 0 }}
            transition={{ type: "spring", stiffness: 400, damping: 10 }}
            onClick={handleBookmarkClick}
          >
            {isFavorite ? (
              <BookmarkCheck size={18} color="var(--primary-blue)" />
            ) : (
              <Bookmark size={18} color="var(--primary-blue)" />
            )}
          </BookmarkIconWrapper>
        )}
        {isVideo ? (
          <CardVideo src={src} autoPlay muted loop>
            <track kind="captions" />
          </CardVideo>
        ) : (
          <CardImage src={src} />
        )}
      </ImageWrapper>
      <motion.div
        animate={{ opacity: showKPIs ? 1 : 0 }}
        transition={{ ease: "easeInOut", duration: 0.1 }}
        style={{ pointerEvents: showKPIs ? "auto" : "none" }}
      >
        <CardFooter>
          <Metrics>
            <Metric>
              CPC
              <span>--</span>
            </Metric>
            <Metric>
              Clicks
              <span>--</span>
            </Metric>
            <Metric>
              CTR
              <span>--</span>
            </Metric>
          </Metrics>
        </CardFooter>
      </motion.div>
      {/* <ActionButton>{t("Use")}</ActionButton> */}
    </CardContainer>
  );
};

export default MediaCard;
